"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _TagsGroup = _interopRequireDefault(require("../TagsGroup/TagsGroup"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
(function () {
  const styles = ":export {\n  primary-SIAblack: #000000;\n  primary-SIAgraydark: #4c4c4c;\n  primary-SIAgrayMiddle: #a8a8a8;\n  primary-SIAgray: #d4d4d4;\n  primary-SIAgrayLight: #e8e8e8;\n  primary-SIAgrayVeryLight: #f4f4f4;\n  primary-SIAwhite: #fff;\n  primary-SIAred: #e41b13;\n  primary-SIAredDark: #99100a;\n  secondary-SIAazure: #8caddb;\n  secondary-SIAazureLight: #e9eff7;\n  secondary-SIAbronze: #b1997e;\n  secondary-SIAbronzeLight: #efebe5;\n  secondary-SIAgreen: #2fb789;\n  secondary-SIAgreenLight: #ecf7f3;\n  secondary-SIAorange: #f3743d;\n  secondary-SIAorangeLight: #fbf1ec;\n  secondary-SIArose: #e6005f;\n  secondary-SIAroseLight: #fcf2f7;\n  secondary-SIAyellow: #dacd7e;\n  secondary-SIAyellowLight: #faf8ed; }\n\n.SIAMember-container {\n  box-sizing: content-box;\n  margin: auto; }\n  .SIAMember-container a {\n    text-decoration: none; }\n  .SIAMember-container .info-container {\n    max-width: 100%;\n    width: 244px; }\n  .SIAMember-container img {\n    width: 100%;\n    height: auto;\n    aspect-ratio: 1;\n    object-fit: cover; }\n  .SIAMember-container .name {\n    margin-bottom: 0px; }\n  .SIAMember-container .professional_function {\n    max-width: 204px; }\n  .SIAMember-container .diploma_title {\n    margin-top: 2px; }\n  .SIAMember-container .tags-group {\n    display: flex;\n    flex-wrap: wrap; }\n  .SIAMember-container .bx--tag {\n    display: flex;\n    align-items: center; }\n    .SIAMember-container .bx--tag span {\n      font-family: 'Helvetica Neue LT Roman';\n      line-height: 100%;\n      text-decoration: none !important; }\n  @media (max-width: 66rem) {\n    .SIAMember-container .info-container {\n      max-width: 100%;\n      width: 312px; } }\n  @media (max-width: 42rem) {\n    .SIAMember-container .info-container {\n      max-width: 100%;\n      width: 288px; } }\n";
  const fileName = "SIAMember_SIAMember";
  const element = document.querySelector("style[data-sass-component='SIAMember_SIAMember']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
const SIAMember = _ref => {
  let {
    Component,
    url,
    picture,
    firstname,
    lastname,
    academic_title,
    title_translated,
    city,
    member_type,
    quinaryTags,
    quaternaryTags,
    tertiaryTags,
    ...props
  } = _ref;
  const quinaryTagsObjects = quinaryTags?.map(el => {
    return {
      label: el,
      type: 'quinary'
    };
  }) || [];
  const quaternaryTagsObjects = quaternaryTags?.map(el => {
    return {
      label: el,
      type: 'quaternary'
    };
  }) || [];
  const tertiaryTagsObjects = tertiaryTags?.map(el => {
    return {
      label: el,
      type: 'tertiary'
    };
  }) || [];
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "SIAMember-container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "info-container sia-margin-02-left sia-border-01-bottom sia-padding-03-bottom sia-margin-02-bottom"
  }, /*#__PURE__*/_react.default.createElement(Component, _extends({
    to: url,
    className: "SIAMember-link"
  }, props), picture && /*#__PURE__*/_react.default.createElement("img", {
    className: "sia-margin-02-bottom",
    src: picture,
    alt: firstname
  }), (academic_title || title_translated) && /*#__PURE__*/_react.default.createElement("h3", {
    className: "name sia-text-12"
  }, academic_title || title_translated), /*#__PURE__*/_react.default.createElement("h3", {
    className: "name sia-text-12"
  }, lastname), /*#__PURE__*/_react.default.createElement("h3", {
    className: "sia-text-12 sia-margin-02-bottom"
  }, firstname)), /*#__PURE__*/_react.default.createElement("p", {
    className: "role sia-text-03",
    style: {
      margin: 0
    }
  }, city), /*#__PURE__*/_react.default.createElement("div", {
    className: "sia-text-08 sia-margin-02-top"
  }, /*#__PURE__*/_react.default.createElement(_TagsGroup.default, {
    items: [{
      label: member_type,
      type: 'pirmary'
    }, ...quinaryTagsObjects, ...quaternaryTagsObjects, ...tertiaryTagsObjects]
  }))));
};
SIAMember.propTypes = {
  Component: _propTypes.default.elementType.isRequired,
  firstname: _propTypes.default.string,
  lastname: _propTypes.default.string.isRequired,
  picture: _propTypes.default.string,
  url: _propTypes.default.string,
  city: _propTypes.default.string,
  academic_title: _propTypes.default.string,
  title_translated: _propTypes.default.string,
  member_type: _propTypes.default.string,
  quinaryTags: _propTypes.default.array,
  quaternaryTags: _propTypes.default.array,
  tertiaryTags: _propTypes.default.array
};
var _default = exports.default = SIAMember;